// Action Types
export const SET_ROSTER_HISTORY = 'SET_ROSTER_HISTORY';
export const SET_ROSTER_HISTORY_LOADED = 'SET_ROSTER_HISTORY_LOADED';
export const SHOW_ROSTER_HISTORY_LOADING_SPINNER = 'SHOW_ROSTER_HISTORY_LOADING_SPINNER';

// Action Creator
const RosterHistoryActionCreator = {
  setRosterHistory(history: any) {
    return {
      type: SET_ROSTER_HISTORY,
      payload: history
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_ROSTER_HISTORY_LOADING_SPINNER,
      payload: show
    };
  }
};

export default RosterHistoryActionCreator;
